document.addEventListener("DOMContentLoaded", () => {
  // Only run on desktop
  if (window.innerWidth >= 1200) {
    const image = document.querySelector(".dosage-info__main-image");
    const container = document.querySelector(".dosage-info");

    // Initial rotation
    image.style.transform = "rotate(0deg)";

    window.addEventListener("scroll", () => {
      // Get the container's position relative to viewport
      const rect = container.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // Calculate how far through the section we've scrolled (0 to 1)
      // Multiply by 1.5 to reach max rotation earlier
      let progress =
        ((windowHeight - rect.top) / (windowHeight + rect.height)) * 1.5;
      progress = Math.max(0, Math.min(1, progress)); // Clamp between 0 and 1

      // Calculate rotation (0 to 2.3 degrees)
      const rotation = progress * 2.3;

      // Apply rotation
      image.style.transform = `rotate(${rotation}deg)`;
    });
  }
});
